import firebase from '@/firebase'
const db = firebase.db

const state = {
  ekrmMetrics: [],
  referenceMetrics: []
}

const getters = {
  ekrmMetrics: state => {
    return state.ekrmMetrics
  },
  referenceMetrics: state => {
    return state.referenceMetrics
  }
}

const actions = {
  loadEkrmMetrics (context, payload) {
    return new Promise((resolve, reject) => {
      db.collection('stats').doc('clients').collection('created').where('type', '==', 'ekrm').get().then((snapshot) => {
        let ekrms = []
        snapshot.forEach(doc => {
          ekrms.push(doc.data())
        })
        context.commit('setEkrmMetrics', {
          ekrmMetrics: ekrms
        })
        resolve()
      })
    })
  },
  loadReferenceMetrics (context, payload) {
    return new Promise((resolve, reject) => {
      // Load all reference models
      db.collection('reference_models').get().then((refSnapshot) => {
        // Load all custom models
        db.collection('clients').where('type', '!=', 'mmm').get().then((clientsSnapshot) => {
          let referenceMetrics = []

          // Calculate 90 days ago timestamp
          const ninetyDaysAgo = Date.now() - (90 * 24 * 60 * 60 * 1000)

          // Process each reference model
          refSnapshot.forEach(refDoc => {
            const refData = refDoc.data()

            // Count how many custom models use this reference
            let customModelCount = 0
            let customModelCountLast90Days = 0
            clientsSnapshot.forEach(clientDoc => {
              const clientData = clientDoc.data()
              if (clientData.reference_model && clientData.reference_model.codename === refDoc.id) {
                customModelCount++

                // Check if created in last 90 days
                if (clientData.date_created && clientData.date_created.toMillis() > ninetyDaysAgo) {
                  customModelCountLast90Days++
                }
              }
            })

            // Extract category from config
            let category = ''
            if (refData.config && refData.config.category) {
              category = refData.config.category
            }

            referenceMetrics.push({
              id: refDoc.id,
              codename: refData.codename || refDoc.id,
              category: category,
              date_created: refData.date_created,
              created_by: refData.created_by,
              customModelCount: customModelCount,
              customModelCountLast90Days: customModelCountLast90Days
            })
          })

          context.commit('setReferenceMetrics', {
            referenceMetrics: referenceMetrics
          })
          resolve()
        }).catch((error) => {
          console.error('Error loading custom models:', error)
          reject(error)
        })
      }).catch((error) => {
        console.error('Error loading reference models:', error)
        reject(error)
      })
    })
  }
}
const mutations = {
  setEkrmMetrics (state, payload) {
    state.ekrmMetrics = payload.ekrmMetrics
  },
  setReferenceMetrics (state, payload) {
    state.referenceMetrics = payload.referenceMetrics
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
